import Vue from 'vue'
import Vuex from 'vuex'
import Rich, { Lazyload, createAPI } from '@didi/rich-ui'
import Locale from '@didi/rich-ui/lib/locale'
import enUSMessages from '@didi/rich-ui/lib/locale/lang/en-US'
import esMXMessages from '@didi/rich-ui/lib/locale/lang/es-MX'
import ptBRMessages from '@didi/rich-ui/lib/locale/lang/pt-BR'
import jaJPMessages from '@didi/rich-ui/lib/locale/lang/ja-JP'
import esCRMessages from '@/config/locale/lang/es-CR'
import initGlobalFilters from './filters'
import initGlobalDirectives from './directives'
import Viewer from 'v-viewer'
import {
  i18n,
  getBDLocale,
  getBDCountry,
  setBDLocale,
  setBDCountry,
  setBDTimezone
} from './common/utils/i18n'
import { getUserInfo, getUserInfoBrief, setCountryLocale } from '@/api'
import { trackEvent } from '@/common/utils/log'
import { urlParse } from '@/common/utils/util'

import storage from 'didi-store'
import FullScreenSelect from '@/components/FullScreenSelect.vue'
import FullScreenVisitObject from '@/components/FullScreenVisitObject.vue'
import FullScreenAddVisitObject from '@/components/FullScreenAddVisitObject.vue'
import VisitObjectListPopup from '@/pages-v2/Visit/components/form/VisitObjectPicker/components/VisitObjectListPopup/index.vue'
import AddVisitObjectPopup from '@/pages-v2/Visit/components/form/VisitObjectPicker/components/AddVisitObjectPopup/index.vue'
import AddBrandVisitObjectPopup from '@/pages-v2/Visit/components/form/BrandVisitObjectPicker/components/AddVisitObjectPopup.vue'
import GasVisitObjectListPopup from '@/pages-v2/Gas/VisitGas/components/form/VisitObjectPicker/components/VisitObjectListPopup/index.vue'
import GasAddVisitObjectPopup from '@/pages-v2/Gas/VisitGas/components/form/VisitObjectPicker/components/AddVisitObjectPopup/index.vue'
import FullScreenBizTime from '@/components/FullScreenBizTime.vue'
import FullScreenGasBizTime from '@/components/FullScreenGasBizTime.vue'
import FullScreenPoiPicker from '@/components/FullScreenPoiPicker.vue'
import FullScreenBankSearch from '@/components/FullScreenBankSearch.vue'
import FullCutPicture from '@/components/FullCutPicture.vue'
import FullHorShowChart from '@/pages-v2/ShopDetail/components/Diagnosis/components/FullHorShowChart/index.vue'
import GasFullHorShowChart from '@/pages-v2/Gas/ShopDetailGas/components/bizoppComponents/GasFullHorShowChart/index.vue'
import FullScreenBankBranchSearch from '@/components/FullScreenBankBranchSearch.vue'
import FullScreenBankSelect from '@/components/FullScreenBankSelect.vue'
import FullScreenSugSelUser from '@/components/SugSelUser.vue'
import FullScreenSugSelImei from '@/components/SugSelImei.vue'
import FullScreenUserSugSelect from '@/components/UserSugSelect.vue'
import FullScreenBusinessInfo from '@/pages/visit/addvisit/FullScreenBusinessInfo.vue'
import FullScreenCloseVisit from '@/components/visitDetail/FullScreenCloseVisit.vue'
import MultiSelectPicker from '@/components/MultiSelectPicker.vue'
import {
  initEntryH5DataSet,
  initEntryH5VueInstance,
  getLastNotLoginTimestamp,
  trackLoginProcessByPhase
} from './init'
import { GlobalUserInfoLocalStorageKey } from './common/utils/constant'
import { BIZ_IDS, isAbasteceBiz } from './common/utils/BizUtils'


export default function() {
  const messageMap = {
    'en-US': enUSMessages,
    'es-MX': esMXMessages,
    'pt-BR': ptBRMessages,
    'ja-JP': jaJPMessages,
    'es-CR': esCRMessages
  }
  let localLocale = getBDLocale()
  // 前置init app
  Vue.use(Vuex)
  Vue.use(Rich)
  Vue.use(Viewer)
  Vue.use(Lazyload, {
    preload: 1,
    attempt: 3,
    filter: {
      progressive(listener, options) {
        const size = listener.el.getAttribute('crop-size')
        // SODA 图床暂只支持soda-public的服务
        const isSodaPublic = /soda-public/
        if (size && isSodaPublic.test(listener.src)) {
          listener.src = `${listener.src}!${size}_m`
        }
      }
    }
  })
  Vue.use(Locale)
  initGlobalFilters()
  initGlobalDirectives()
  Vue.use(i18n.plugin)
  // set rich-ui locale
  Locale.use(localLocale, messageMap[localLocale])

  createAPI(Vue, FullScreenSelect, ['click'], true)
  createAPI(Vue, FullScreenBizTime, ['click'], true)
  createAPI(Vue, FullScreenGasBizTime, ['click'], true)
  createAPI(Vue, FullScreenPoiPicker, ['click'], true)
  createAPI(Vue, FullScreenBankSearch, ['click'], true)
  createAPI(Vue, FullCutPicture, ['click'], true)
  createAPI(Vue, FullHorShowChart, ['click'], true)
  createAPI(Vue, GasFullHorShowChart, ['click'], true)
  createAPI(Vue, FullScreenBankBranchSearch, ['click'], true)
  createAPI(Vue, FullScreenBankSelect, ['click'], true)
  createAPI(Vue, FullScreenSugSelUser, ['click'], true)
  createAPI(Vue, FullScreenSugSelImei, ['click'], true)
  createAPI(Vue, FullScreenUserSugSelect, ['click'], true)
  createAPI(Vue, FullScreenBusinessInfo, ['click'], true)
  createAPI(Vue, FullScreenCloseVisit, ['click'], true)
  createAPI(Vue, MultiSelectPicker, ['click'], true)
  createAPI(Vue, FullScreenVisitObject, ['click'], true)
  createAPI(Vue, FullScreenAddVisitObject, ['click'], true)
  createAPI(Vue, VisitObjectListPopup, ['click'], true)
  createAPI(Vue, AddVisitObjectPopup, ['click'], true)
  createAPI(Vue, GasVisitObjectListPopup, ['click'], true)
  createAPI(Vue, GasAddVisitObjectPopup, ['click'], true)
  createAPI(Vue, AddBrandVisitObjectPopup, ['click'], true)
  /* eslint-disable no-new */
  function getUserInfoForLocalStorageOrRemote() {
    const LocalUserInfo = storage.get(GlobalUserInfoLocalStorageKey)

    // 前置打点
    const query = urlParse(location.href)
    if (query.sso_duration && window.Soda && window.Soda.removeTicket) {
      trackLoginProcessByPhase(3, +query.sso_duration, {
        native: 1
      })
    }

    if (LocalUserInfo) {
      Promise.resolve(LocalUserInfo)
        .then(async res => {
          return initEntryH5DataSet(res)
        })
        .then(data => {
          initEntryH5VueInstance(data, messageMap)
        })
        .finally(() => {
          handlerRemoteUserInfo()
        })
    } else {
      handlerRemoteUserInfo()
    }

    // 执行后续处理函数
    function handlerRemoteUserInfo() {
      const notLoginTimestamp = getLastNotLoginTimestamp()
      const now = +new Date()
      const duration = window.performance
        ? window.performance.now()
        : now - window.pageLoadStartTime
      if (!notLoginTimestamp) {
        // 未登录首次进入
        trackLoginProcessByPhase(1, duration)
      } else {
        // 从未登录 -> 登录成功二次进入
        trackLoginProcessByPhase(4, duration)
      }
      getRemoteUserInfo(now, duration)
    }

    function getRemoteUserInfo(current = +new Date(), loadDuration = 0) {
      Promise.all([getUserInfo({ current }), getUserInfoBrief()])
        .then(async ([res, bizRes]) => {
          const loginTrackParams = {
            country: getBDCountry(),
            type: 1 // 2: 登录链路 1: 正常链路
          }
          const notLoginTimestamp = getLastNotLoginTimestamp()
          const duration = +new Date() - current
          if (!notLoginTimestamp) {
            trackLoginProcessByPhase(2, duration)
            loginTrackParams.type = 1
          } else {
            // 从未登录 -> 登录成功二次进入
            trackLoginProcessByPhase(
              3,
              current - notLoginTimestamp - loadDuration
            )
            trackLoginProcessByPhase(5, duration)
            storage.remove('notLoginToRedirect')
            loginTrackParams.type = 2
          }

          trackEvent('sailing_gattarman_x_login_success_en', loginTrackParams)
          res.data.bizId = bizRes?.data?.bizId || BIZ_IDS.FOOD

          if (isAbasteceBiz(res.data.bizId) && !getBDCountry()) {
            const locale = 'pt-BR'
            // TODO: 首次进来写死了，后面需要 I侧后端(耿嘉亮)处理(对bizId不同进行不同默认国家处理)
            const country = 'BR'
            const timezone = 'America/Sao_Paulo'
            res.data.locale = locale
            res.data.country = country
            res.data.timezone = timezone
            setBDLocale(locale)
            setBDCountry(country)
            setBDTimezone(timezone)
            storage.set('language', locale) // 新增代码
            setCountryLocale({
              locale,
              country,
              timezone
            })
              .then(res => {
                setBDLocale(locale)
                setBDCountry(country)
                setBDTimezone(timezone)
                storage.set('language', locale) // 新增代码
                window.location.reload()
              })
              .catch(err => {
                console.log('[log] err =>', err)
              })
            return null
          }
          return initEntryH5DataSet(res)
        })
        .then(data => {
          if (data) initEntryH5VueInstance(data, messageMap)
        })
    }
  }
  getUserInfoForLocalStorageOrRemote()
}
